export default {
  challenge: {
    co2: {
      title: 'Klimautfordringen',
      description: '',
      image: '',
    },
    climate: {
      title: 'Klimautfordringen',
      description: '',
      image: '',
    },
    workTransport: {
      title: 'Jobbtransportutfordringen',
      description: '',
      image: '',
    },
    foodWaste: {
      title: 'Matsvinnutfordringen',
      description: '',
      image: '',
    },
    food_waste: {
      title: 'Matsvinnutfordringen',
      description: '',
      image: '',
    },
    plastic: {
      title: 'Plastutfordringen',
      description: '',
      image: '',
    },
    mindfulCitizen: {
      title: 'Omsorgsfull innbygger utfordringen',
      description: '',
      image: '',
    },
    atWork: {
      title: 'Utfordringen på jobb',
      description: '',
      image: '',
    },
  },
};
